import React, {Component} from 'react';  
 
import axios from "axios"; 
import { StageSpinner , HeartSpinner } from "react-spinners-kit"; 
import config from  '../../config';

class SignUpForm1 extends Component{
    constructor(props) {
        super(props);
        this.state = {
            code: this.props.code ,
            step: 2,
            messageBox: '',
            messageBoxState: 0,
            loading: false,
        }
    }

    backStep = () => { 

        this.props.backStep();
    }
  
    handleChange(e) { 
         this.setState({code: e.target.value}); 
    }

    sendRequest = () =>{ 

        const XSmode = document.getElementById('xs-online-app').getAttribute('data-mode');
  
          this.setState({messageBox: 'Loading....' });
          this.setState({loading: true });
          let data  = { 
                  action: 'signUpSubscriptionTokenActivation', 
                  formdata: {
                      code: this.state.code,  
                      xsmode: XSmode,  
                      ctype: 'sms',  
                      action: 'singup-step2', 
                  }
          }; 
         
          axios.post( config.API_URL ,JSON.stringify(data) ,{  
                  dataType: 'json',               
                  cache: false, 
                  headers: {   
                    "Content-Type": "application/json",  
                    "cache-control": "no-cache"
                  }  
                }                
              )
              .then(res => { 
                  console.log( res );
                  this.setState({messageBox: res.data.message })
                  this.setState({messageBoxState: 0 })

                  if( res.data.state > 0 ){ 

                    this.setState({messageBoxState: res.data.state });
                    this.setState({loading: false })
                    this.setState({code: ''});

                    sessionStorage.setItem(XSmode + '-xsValidation',this.state.code) ;
                    
                    sessionStorage.setItem(XSmode + '-fullname',res.data.fullname) ;
                    sessionStorage.setItem(XSmode + '-email',res.data.email) ;
                    sessionStorage.setItem(XSmode + '-phone',res.data.phone) ;
                    
                    if( res.data.state == 2 ){ 
                       window.location.href = res.data.url;
                    }
                    
                  } else {

                    this.setState({messageBoxState: res.data.state  });
                    this.setState({messageBox: res.data.message });
                    this.setState({loading: false })
                  }
              });  
      } 
 
    render(){ 
       
        return (
            <div className="container-fluid"> 

                <div className="signupInfoBox "  >
                    <div id="div_id_stagename" className="form-group"  > 
                        <label for="id_stagename" className="control-label col-lg-12 form-label requiredField text-start" >
                            Activation Code  </label> 
                        <div className="controls col-lg-12 form-field"> 
                            <input className="required input-sm textinput textInput form-control" 
                            id="id_stagename" maxlength="100" name="stagename" placeholder="" type="text"
                            value={this.state.code } onChange={(e) => {this.handleChange(e)} } /> 
                        </div> 
                    </div>  

                    <div className="clear"></div>

                    <div className={this.state.messageBoxState ? 'messageBox errorMsg' : ' messageBox successMsg'} >
                             
                             <HeartSpinner
                                 size={40}
                                 color="#e4000d" 
                                 loading={this.state.loading}
                             />  
                             <div className={this.state.messageBoxState ? 'errorMsg' : ' successMsg'} > {this.state.messageBox}</div>
                    </div>

                    <div className="row buttonsBox buttonsBoxStep2">

                            <div className="col-md-1">&nbsp;</div>

                            <div className="col-md-5"> 
                                <input type="submit" name="resend-code" value="Sending new code "  
                                    className="btn btn-primary btn-warning btn-block register-now-btn  " 
                                    id="submit-id-sign-up" onClick={this.backStep}   />
                            </div>

                            <div className="col-md-5">
                                <input type="submit" name="sign-up" value="Validate code"  
                                className="btn btn-primary btn-primary btn-block register-now-btn g-recaptcha" 
                                id="submit-id-sign-up" onClick={this.sendRequest}   />  
                            </div> 
                           
                            <div className="col-md-1">&nbsp;</div>
                    </div> 

                        <div className="clear"></div>
                            <div>
                                <p>
                                    Еnter the code you received in the cell phone as SMS
                                </p>
                            </div>
                        </div>

    </div>
         )
    }


}



export default SignUpForm1;